import { useEffect, useState } from "react";
import { useAccount, useCurrentUser } from "@zapier/client";
import { WOOTRIC_NO_SURVEYED_COOKIE, WOOTRIC_SURVEY_IMMEDIATELY } from "../../../utils/src";
const Wootric = () => {
  const {
    user
  } = useCurrentUser();
  const {
    account
  } = useAccount();
  const {
    currentAccountId: accountId,
    id: userId,
    email: emailAddress,
    roles
  } = user || {};
  const {
    paying,
    isTrialing,
    isTrialingCompanies,
    isTrialingTeams,
    planInfo,
    createdAt,
    planGroupId,
    periodStart,
    periodEnd
  } = account || {};
  const planName = planInfo?.name;
  const isFree = !paying;
  const currentBillingPeriod = {
    from: periodStart ? new Date(periodStart) : undefined,
    to: periodEnd ? new Date(periodEnd) : undefined
  };
  const currentUserRole = roles?.find(role => role.accountId === accountId)?.role;
  const [wootricHasInitialized, setWootricHasInitialized] = useState(false);
  let userCreatedAtUnix: number | null;
  if (createdAt) {
    userCreatedAtUnix = Math.floor(new Date(createdAt).getTime()) / 1000;
  }
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const language = Intl.DateTimeFormat().resolvedOptions().locale;
  useEffect(() => {
    // only run this if wootric has not initialized and we have user data
    if (!wootricHasInitialized && user && account) {
      const setupScript = document.createElement("script");
      setupScript.type = "text/javascript";
      setupScript.id = "wootric-settings";
      setupScript.async = true;

      // NEXT_PUBLIC_WOOTRIC_ACCOUNT_TOKEN is safe to be saved in .env files since
      // it's interpolated into the script tag on the client side anyway, so it will always be exposed to any user who inspects the page
      setupScript.innerHTML = `
      wootric_no_surveyed_cookie = ${WOOTRIC_NO_SURVEYED_COOKIE};
      wootric_survey_immediately = ${WOOTRIC_SURVEY_IMMEDIATELY};
      window.wootricSettings = {
        account_token: "${process.env.NEXT_PUBLIC_WOOTRIC_ACCOUNT_TOKEN}",
        aria: true,
        created_at: ${userCreatedAtUnix},
        email: "${emailAddress}",
        modal_footprint: "compact",
        properties: {
          account_id: "${accountId}",
          account_is_free: "${isFree}",
          account_is_trialing: "${isTrialing}",
          account_is_trialingCompanies: "${isTrialingCompanies}",
          account_is_trialingTeams: "${isTrialingTeams}",
          customuser_id: "${userId}",
          date_last_charge: "${currentBillingPeriod.from?.toISOString()}",
          date_next_charge: "${currentBillingPeriod.to?.toISOString()}",
          date_user_created: "${createdAt}",
          email: "${emailAddress}",
          language: "${language}",
          plan_group_id: "${planGroupId}",
          plan_tier: "${planName}",
          role: "${currentUserRole}",
          timezone: "${timezone}",
        },
      };
    `;
      if (document.getElementById("wootric-settings") == null) {
        document.body.appendChild(setupScript);
      }

      // Beacon
      const beacon = document.createElement("script");
      beacon.type = "text/javascript";
      beacon.id = "wootric-beacon";
      beacon.async = true;
      beacon.src = "https://cdn.wootric.com/wootric-sdk.js";
      beacon.onload = function () {
        // @ts-ignore
        window.wootric("run");
      };
      if (document.getElementById("wootric-beacon") == null) {
        document.body.appendChild(beacon);
      }
      setWootricHasInitialized(true);
    }
  }, [wootricHasInitialized, user, account]);
  return null;
};
export default Wootric;